import { Container } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  margin: 0px auto;
  width: 100%;
  padding: 0px 1.5rem;
`;

export const StyledBannerContainer = styled(Container)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  position: relative;
`;

export const StyledBannerImage = styled.div`
  z-index: -1;

  > img {
    max-width: 18.6rem;
    width: 100%;
  }
`;

export const StyledTabContent = styled.section`
  display: flex;
  gap: 2rem;
  flex-direction: column;
  width: 100%;
  padding: 2rem 0 2rem 0;
`;

export const StyledHeader = styled.section`
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 1.6rem;
`;

export const StyledFormGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1.6rem;
  width: 100%;
  flex: 1 1 0%;
  align-items: center;

  > div {
    display: flex;
    width: 100%;
    gap: 1.6rem;
    justify-content: end;
  }

  > button {
    white-space: nowrap;
  }
`;

export const StyledLimit = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;

  > span {
    font-size: large;
    color: ${({ theme }) => theme.colors.text.main};
  }

  > div {
    display: flex;
    width: 100%;
    flex: 1 1 0%;

    > div {
      width: 8rem;
    }
  }
`;

export const StyledPanelGroup = styled.section`
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
`;

export const StyledPanel = styled.section`
  flex: 50 1 0;
`;

export const StyledEmptyDataLabel = styled.p`
  text-align: center;
  color: ${({ theme }) => theme.colors.text.main};
`;
